// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.finiquitos-view {
  display: grid;
  gap: var(--ui-space-5);
  padding-bottom: var(--ui-space-6);
}

.finiquitos-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ui-space-4);
  padding: var(--ui-space-5);
  border-radius: var(--ui-radius-xl);
  border: 1px solid var(--ui-border);
  background:
    radial-gradient(circle at top right, rgba(29, 90, 124, 0.12), transparent 38%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(248, 252, 255, 0.94));
  box-shadow: var(--ui-elevation-2);
}

.finiquitos-header h2 {
  margin: 0.1rem 0 0;
  font-size: clamp(1.8rem, 2vw, 2.35rem);
}

.finiquitos-header .subtitle {
  max-width: 62ch;
}

.finiquitos-status-stack {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.55rem;
}

.status-badge,
.finiquitos-section-label {
  display: inline-flex;
  align-items: center;
  min-height: 2rem;
  padding: 0.28rem 0.75rem;
  border-radius: var(--ui-radius-pill);
  border: 1px solid var(--ui-border);
  background: rgba(255, 255, 255, 0.82);
  color: var(--ui-text-soft);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.status-badge.ready {
  border-color: rgba(20, 114, 79, 0.2);
  background: rgba(20, 114, 79, 0.1);
  color: var(--ui-success);
}

.status-badge.warning {
  border-color: rgba(149, 109, 21, 0.24);
  background: rgba(149, 109, 21, 0.1);
  color: var(--ui-warning);
}

.status-badge.neutral {
  background: rgba(29, 90, 124, 0.08);
  color: var(--ui-accent);
}

.status-badge.danger {
  border-color: rgba(156, 60, 50, 0.22);
  background: rgba(156, 60, 50, 0.1);
  color: var(--ui-danger);
}

.finiquitos-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(320px, 0.9fr);
  gap: var(--ui-space-5);
  align-items: start;
}

.finiquitos-main,
.finiquitos-side {
  display: grid;
  gap: var(--ui-space-4);
}

.finiquitos-side {
  position: sticky;
  top: 0.75rem;
}

.finiquitos-panel,
.finiquitos-subpanel {
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-xl);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(247, 251, 254, 0.94));
  box-shadow: var(--ui-elevation-1);
}

.finiquitos-panel {
  padding: var(--ui-space-5);
}

.finiquitos-subpanel {
  padding: var(--ui-space-4);
}

.finiquitos-panel-body {
  display: grid;
  gap: var(--ui-space-4);
}

.finiquitos-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ui-space-3);
}

.finiquitos-section-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}

.finiquitos-section-header h3 {
  margin: 0.1rem 0 0;
  font-size: 1.2rem;
}

.finiquitos-section-header .subtitle {
  max-width: 68ch;
}

.finiquitos-grid-two {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--ui-space-4);
}

.finiquitos-grid-three {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ui-space-4);
}

.finiquitos-span-full {
  grid-column: 1 / -1;
}

.finiquitos-select select,
.finiquitos-grid-two input,
.finiquitos-grid-three input,
.finiquitos-row input,
.finiquitos-row select {
  width: 100%;
}

.finiquitos-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.finiquitos-search-tools {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(220px, 0.8fr) auto;
  gap: 0.75rem;
  align-items: end;
}

.finiquitos-search-hint {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.finiquitos-clear-search {
  align-self: end;
}

.finiquitos-spreadsheet-wrap {
  overflow: auto;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.finiquitos-collapsed-panel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.7rem;
  padding: 0.85rem 0.95rem;
  border: 1px dashed rgba(42, 78, 102, 0.28);
  border-radius: var(--ui-radius-lg);
  background: rgba(255, 255, 255, 0.72);
}

.finiquitos-collapsed-panel .helper-text {
  margin: 0;
}

.Spreadsheet {
  min-width: 520px;
}

.Spreadsheet__table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.Spreadsheet__corner,
.Spreadsheet__header,
.Spreadsheet__row-header {
  background: rgba(29, 90, 124, 0.06);
  color: var(--ui-text-soft);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.Spreadsheet__corner,
.Spreadsheet__header {
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 1px solid var(--ui-border);
  padding: 0.7rem 0.8rem;
}

.Spreadsheet__corner {
  left: 0;
  z-index: 3;
}

.Spreadsheet__row-header {
  position: sticky;
  left: 0;
  z-index: 1;
  border-right: 1px solid var(--ui-border);
  border-bottom: 1px solid rgba(42, 78, 102, 0.12);
  padding: 0.65rem 0.8rem;
}

.Spreadsheet__cell {
  border-right: 1px solid rgba(42, 78, 102, 0.08);
  border-bottom: 1px solid rgba(42, 78, 102, 0.08);
}

.Spreadsheet__cell input {
  width: 100%;
  min-width: 0;
  border: 0;
  background: transparent;
  color: var(--ui-text);
  font: inherit;
  padding: 0.7rem 0.8rem;
}

.Spreadsheet__cell input:focus {
  outline: 2px solid rgba(29, 90, 124, 0.22);
  outline-offset: -2px;
  background: rgba(29, 90, 124, 0.06);
}

.finiquitos-row-list {
  display: grid;
  gap: 0.75rem;
}

.finiquitos-concept-picker {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.8rem;
  margin: var(--ui-space-3) 0 var(--ui-space-4);
  padding: 0.85rem;
  border: 1px solid rgba(42, 78, 102, 0.12);
  border-radius: var(--ui-radius-lg);
  background: linear-gradient(180deg, rgba(245, 250, 253, 0.9), rgba(255, 255, 255, 0.88));
}

.finiquitos-concept-picker-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.finiquitos-concept-picker-head span:not(.status-badge) {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ui-text-soft);
}

.finiquitos-concept-picker-head p {
  margin: 0.18rem 0 0;
  color: var(--ui-text-soft);
  font-size: 0.86rem;
}

.finiquitos-concept-select-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.65rem;
  align-items: end;
}

.finiquitos-concept-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.45rem;
  max-height: 11.5rem;
  overflow: auto;
  padding-right: 0.15rem;
}

.finiquitos-concept-option {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  min-height: 2.55rem;
  padding: 0.55rem 0.65rem;
  border: 1px solid rgba(42, 78, 102, 0.12);
  border-radius: var(--ui-radius-md);
  background: rgba(255, 255, 255, 0.8);
  color: var(--ui-text);
  cursor: pointer;
  transition:
    border-color 140ms ease,
    background 140ms ease,
    box-shadow 140ms ease;
}

.finiquitos-concept-option:hover {
  border-color: rgba(29, 90, 124, 0.28);
  background: rgba(255, 255, 255, 0.96);
}

.finiquitos-concept-option.selected {
  border-color: rgba(20, 114, 79, 0.28);
  background: rgba(20, 114, 79, 0.08);
  box-shadow: inset 3px 0 0 rgba(20, 114, 79, 0.55);
}

.finiquitos-concept-option input {
  margin-top: 0.12rem;
}

.finiquitos-concept-option span {
  font-size: 0.86rem;
  line-height: 1.25;
}

.finiquitos-concept-picker .btn {
  justify-self: end;
}

.finiquitos-row {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(120px, 0.42fr) minmax(0, 1fr) auto;
  gap: 0.7rem;
  align-items: end;
}

.finiquitos-row.with-type {
  grid-template-columns: minmax(140px, 0.55fr) minmax(0, 1.2fr) minmax(120px, 0.42fr) minmax(0, 1fr) auto;
}

.compact-field {
  min-width: 0;
}

.compact-field span {
  font-size: 0.72rem;
}

.grow {
  min-width: 0;
}

.amount-field {
  max-width: 8.5rem;
}

.remove-row-btn {
  align-self: center;
  min-width: 2.4rem;
  padding-inline: 0;
}

.finiquitos-summary-panel {
  position: sticky;
  top: 0.75rem;
}

.finiquitos-alert {
  padding: 0.9rem 1rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid var(--ui-border);
  background: rgba(255, 255, 255, 0.92);
}

.finiquitos-alert strong {
  display: block;
  margin-bottom: 0.35rem;
}

.finiquitos-alert ul {
  margin: 0;
  padding-left: 1.1rem;
}

.finiquitos-alert.danger {
  border-color: rgba(156, 60, 50, 0.22);
  background: rgba(156, 60, 50, 0.08);
  color: #7f291f;
}

.finiquitos-alert.warning {
  border-color: rgba(149, 109, 21, 0.22);
  background: rgba(149, 109, 21, 0.08);
  color: #7a5a12;
}

.finiquitos-summary-grid,
.finiquitos-insight-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.7rem;
}

.finiquitos-summary-card,
.finiquitos-insight-grid > div {
  display: grid;
  gap: 0.18rem;
  padding: 0.85rem 0.95rem;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  background: rgba(255, 255, 255, 0.86);
}

.finiquitos-summary-card span,
.finiquitos-insight-grid span {
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ui-text-soft);
}

.finiquitos-summary-card strong,
.finiquitos-insight-grid strong {
  font-size: 1rem;
  color: var(--ui-text);
}

.finiquitos-summary-card.emphasized {
  background: linear-gradient(135deg, rgba(29, 90, 124, 0.11), rgba(20, 114, 79, 0.08));
  border-color: rgba(29, 90, 124, 0.22);
}

.finiquitos-doc-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.7rem;
}

.finiquitos-doc-summary-item {
  display: grid;
  gap: 0.18rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid rgba(29, 90, 124, 0.14);
  border-radius: var(--ui-radius-lg);
  background: rgba(29, 90, 124, 0.05);
}

.finiquitos-doc-summary-item span {
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ui-text-soft);
}

.finiquitos-doc-summary-item strong {
  font-size: 0.95rem;
  color: var(--ui-text);
}

.finiquitos-document-preview {
  display: grid;
  gap: 0.85rem;
  padding: 1rem;
  border: 1px solid rgba(29, 90, 124, 0.14);
  border-radius: var(--ui-radius-lg);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(245, 250, 253, 0.96));
}

.finiquitos-document-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.7rem;
}

.finiquitos-document-meta > div {
  display: grid;
  gap: 0.18rem;
  padding: 0.75rem 0.85rem;
  border-radius: var(--ui-radius-md);
  border: 1px solid rgba(42, 78, 102, 0.11);
  background: rgba(255, 255, 255, 0.82);
}

.finiquitos-document-meta span,
.finiquitos-document-table thead th,
.finiquitos-neto-box span,
.finiquitos-neto-box small {
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ui-text-soft);
}

.finiquitos-document-meta strong {
  font-size: 0.92rem;
  color: var(--ui-text);
  word-break: break-word;
}

.finiquitos-document-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(42, 78, 102, 0.12);
  border-radius: var(--ui-radius-lg);
  overflow: hidden;
}

.finiquitos-document-table th,
.finiquitos-document-table td {
  padding: 0.7rem 0.8rem;
  border-bottom: 1px solid rgba(42, 78, 102, 0.08);
  vertical-align: top;
}

.finiquitos-document-table thead th {
  background: rgba(29, 90, 124, 0.06);
  font-weight: 700;
}

.finiquitos-document-table tbody td strong {
  display: block;
}

.finiquitos-document-table tbody td small {
  display: block;
  margin-top: 0.1rem;
  color: var(--ui-text-soft);
}

.finiquitos-document-table .amount-col {
  width: 12rem;
  text-align: right;
  white-space: nowrap;
}

.finiquitos-document-table tfoot th {
  background: rgba(29, 90, 124, 0.04);
  font-weight: 800;
}

.finiquitos-document-table .placeholder {
  color: var(--ui-text-soft);
}

.finiquitos-neto-box {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0.85rem 0.95rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid rgba(20, 114, 79, 0.18);
  background: linear-gradient(135deg, rgba(20, 114, 79, 0.1), rgba(29, 90, 124, 0.06));
}

.finiquitos-neto-box strong {
  font-size: 1.1rem;
  color: var(--ui-text);
}

.finiquitos-generation-block {
  display: grid;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid rgba(29, 90, 124, 0.14);
  border-radius: var(--ui-radius-lg);
  background: linear-gradient(180deg, rgba(29, 90, 124, 0.06), rgba(255, 255, 255, 0.94));
}

.finiquitos-generation-meta,
.finiquitos-document-card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.7rem;
}

.finiquitos-generation-meta > div,
.finiquitos-document-card-grid > div {
  display: grid;
  gap: 0.18rem;
  padding: 0.75rem 0.85rem;
  border-radius: var(--ui-radius-md);
  border: 1px solid rgba(42, 78, 102, 0.11);
  background: rgba(255, 255, 255, 0.82);
}

.finiquitos-generation-meta span,
.finiquitos-document-card-grid span {
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ui-text-soft);
}

.finiquitos-generation-meta strong,
.finiquitos-document-card-grid strong {
  font-size: 0.92rem;
  color: var(--ui-text);
  word-break: break-word;
}

.finiquitos-document-list {
  display: grid;
  gap: 0.8rem;
}

.finiquitos-document-card {
  display: grid;
  gap: 0.8rem;
  padding: 0.95rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid rgba(29, 90, 124, 0.14);
  background: rgba(255, 255, 255, 0.9);
}

.finiquitos-document-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.finiquitos-document-kind {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ui-text-soft);
}

.finiquitos-document-card h4 {
  margin: 0.15rem 0 0;
  font-size: 1rem;
}

.finiquitos-document-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
  align-items: center;
}

.finiquitos-line-items {
  display: grid;
  gap: 0.55rem;
}

.finiquitos-line-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.7rem 0.85rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid rgba(42, 78, 102, 0.11);
  background: rgba(255, 255, 255, 0.76);
}

.finiquitos-line-item strong {
  display: block;
}

.finiquitos-line-item small {
  color: var(--ui-text-soft);
}

.finiquitos-line-item .credit {
  color: var(--ui-success);
  font-weight: 700;
}

.finiquitos-line-item .debit {
  color: var(--ui-danger);
  font-weight: 700;
}

.finiquitos-approval-box {
  display: grid;
  gap: 0.85rem;
  padding: 1rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid rgba(29, 90, 124, 0.14);
  background: linear-gradient(180deg, rgba(245, 250, 253, 0.95), rgba(255, 255, 255, 0.98));
}

.approval-check {
  display: flex;
  gap: 0.7rem;
  align-items: flex-start;
  color: var(--ui-text);
  font-weight: 600;
}

.approval-check.secondary {
  padding: 0.7rem 0.8rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid rgba(149, 109, 21, 0.18);
  background: rgba(149, 109, 21, 0.06);
}

.approval-check input {
  margin-top: 0.2rem;
}

.full-width {
  width: 100%;
}

.helper-text.warning {
  color: var(--ui-warning);
}

.helper-text.success {
  color: var(--ui-success);
}

@media (max-width: 1100px) {
  .finiquitos-layout {
    grid-template-columns: 1fr;
  }

  .finiquitos-side,
  .finiquitos-summary-panel {
    position: static;
  }
}

@media (max-width: 960px) {
  .finiquitos-header {
    flex-direction: column;
  }

  .finiquitos-status-stack {
    justify-content: flex-start;
  }

  .finiquitos-grid-two,
  .finiquitos-grid-three,
  .finiquitos-summary-grid,
  .finiquitos-insight-grid,
  .finiquitos-doc-summary,
  .finiquitos-document-meta,
  .finiquitos-search-tools,
  .finiquitos-generation-meta,
  .finiquitos-document-card-grid {
    grid-template-columns: 1fr;
  }

  .finiquitos-concept-options {
    grid-template-columns: 1fr;
  }

  .finiquitos-concept-picker-head {
    flex-direction: column;
  }

  .finiquitos-concept-select-row {
    grid-template-columns: 1fr;
  }

  .finiquitos-concept-picker .btn {
    justify-self: stretch;
  }

  .finiquitos-row,
  .finiquitos-row.with-type {
    grid-template-columns: 1fr;
  }

  .amount-field {
    max-width: none;
  }
}

@media (max-width: 640px) {
  .finiquitos-panel,
  .finiquitos-subpanel,
  .finiquitos-header {
    padding: var(--ui-space-4);
  }

  .Spreadsheet {
    min-width: 440px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/views-finiquitos.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,kCAAkC;EAClC;;iFAE+E;EAC/E,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,kCAAkC;EAClC,kCAAkC;EAClC;iFAC+E;EAC/E,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,kCAAkC;EAClC,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,0CAA0C;EAC1C,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,wCAAwC;EACxC,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,6CAA6C;EAC7C,gBAAgB;EAChB,yCAAyC;EACzC,kCAAkC;EAClC,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;EACzC,kCAAkC;EAClC,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf;;;yBAGuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kFAAkF;EAClF,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uGAAuG;AACzG;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qFAAqF;EACrF,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,yCAAyC;EACzC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,kCAAkC;EAClC;iFAC+E;AACjF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,kCAAkC;EAClC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;;;;EAIE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,oCAAoC;EACpC,yCAAyC;EACzC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;EACxB,kCAAkC;EAClC,yCAAyC;EACzC,oFAAoF;AACtF;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,kCAAkC;EAClC,uFAAuF;AACzF;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,kCAAkC;EAClC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,yCAAyC;EACzC,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;;;;;;IASE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".finiquitos-view {\n  display: grid;\n  gap: var(--ui-space-5);\n  padding-bottom: var(--ui-space-6);\n}\n\n.finiquitos-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--ui-space-4);\n  padding: var(--ui-space-5);\n  border-radius: var(--ui-radius-xl);\n  border: 1px solid var(--ui-border);\n  background:\n    radial-gradient(circle at top right, rgba(29, 90, 124, 0.12), transparent 38%),\n    linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(248, 252, 255, 0.94));\n  box-shadow: var(--ui-elevation-2);\n}\n\n.finiquitos-header h2 {\n  margin: 0.1rem 0 0;\n  font-size: clamp(1.8rem, 2vw, 2.35rem);\n}\n\n.finiquitos-header .subtitle {\n  max-width: 62ch;\n}\n\n.finiquitos-status-stack {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.55rem;\n}\n\n.status-badge,\n.finiquitos-section-label {\n  display: inline-flex;\n  align-items: center;\n  min-height: 2rem;\n  padding: 0.28rem 0.75rem;\n  border-radius: var(--ui-radius-pill);\n  border: 1px solid var(--ui-border);\n  background: rgba(255, 255, 255, 0.82);\n  color: var(--ui-text-soft);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.status-badge.ready {\n  border-color: rgba(20, 114, 79, 0.2);\n  background: rgba(20, 114, 79, 0.1);\n  color: var(--ui-success);\n}\n\n.status-badge.warning {\n  border-color: rgba(149, 109, 21, 0.24);\n  background: rgba(149, 109, 21, 0.1);\n  color: var(--ui-warning);\n}\n\n.status-badge.neutral {\n  background: rgba(29, 90, 124, 0.08);\n  color: var(--ui-accent);\n}\n\n.status-badge.danger {\n  border-color: rgba(156, 60, 50, 0.22);\n  background: rgba(156, 60, 50, 0.1);\n  color: var(--ui-danger);\n}\n\n.finiquitos-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.55fr) minmax(320px, 0.9fr);\n  gap: var(--ui-space-5);\n  align-items: start;\n}\n\n.finiquitos-main,\n.finiquitos-side {\n  display: grid;\n  gap: var(--ui-space-4);\n}\n\n.finiquitos-side {\n  position: sticky;\n  top: 0.75rem;\n}\n\n.finiquitos-panel,\n.finiquitos-subpanel {\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-xl);\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(247, 251, 254, 0.94));\n  box-shadow: var(--ui-elevation-1);\n}\n\n.finiquitos-panel {\n  padding: var(--ui-space-5);\n}\n\n.finiquitos-subpanel {\n  padding: var(--ui-space-4);\n}\n\n.finiquitos-panel-body {\n  display: grid;\n  gap: var(--ui-space-4);\n}\n\n.finiquitos-section-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--ui-space-3);\n}\n\n.finiquitos-section-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.finiquitos-section-header h3 {\n  margin: 0.1rem 0 0;\n  font-size: 1.2rem;\n}\n\n.finiquitos-section-header .subtitle {\n  max-width: 68ch;\n}\n\n.finiquitos-grid-two {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--ui-space-4);\n}\n\n.finiquitos-grid-three {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--ui-space-4);\n}\n\n.finiquitos-span-full {\n  grid-column: 1 / -1;\n}\n\n.finiquitos-select select,\n.finiquitos-grid-two input,\n.finiquitos-grid-three input,\n.finiquitos-row input,\n.finiquitos-row select {\n  width: 100%;\n}\n\n.finiquitos-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.finiquitos-search-tools {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(220px, 0.8fr) auto;\n  gap: 0.75rem;\n  align-items: end;\n}\n\n.finiquitos-search-hint {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.finiquitos-clear-search {\n  align-self: end;\n}\n\n.finiquitos-spreadsheet-wrap {\n  overflow: auto;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  background: rgba(255, 255, 255, 0.84);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.finiquitos-collapsed-panel {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.7rem;\n  padding: 0.85rem 0.95rem;\n  border: 1px dashed rgba(42, 78, 102, 0.28);\n  border-radius: var(--ui-radius-lg);\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.finiquitos-collapsed-panel .helper-text {\n  margin: 0;\n}\n\n.Spreadsheet {\n  min-width: 520px;\n}\n\n.Spreadsheet__table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.Spreadsheet__corner,\n.Spreadsheet__header,\n.Spreadsheet__row-header {\n  background: rgba(29, 90, 124, 0.06);\n  color: var(--ui-text-soft);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.Spreadsheet__corner,\n.Spreadsheet__header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  border-bottom: 1px solid var(--ui-border);\n  padding: 0.7rem 0.8rem;\n}\n\n.Spreadsheet__corner {\n  left: 0;\n  z-index: 3;\n}\n\n.Spreadsheet__row-header {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  border-right: 1px solid var(--ui-border);\n  border-bottom: 1px solid rgba(42, 78, 102, 0.12);\n  padding: 0.65rem 0.8rem;\n}\n\n.Spreadsheet__cell {\n  border-right: 1px solid rgba(42, 78, 102, 0.08);\n  border-bottom: 1px solid rgba(42, 78, 102, 0.08);\n}\n\n.Spreadsheet__cell input {\n  width: 100%;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ui-text);\n  font: inherit;\n  padding: 0.7rem 0.8rem;\n}\n\n.Spreadsheet__cell input:focus {\n  outline: 2px solid rgba(29, 90, 124, 0.22);\n  outline-offset: -2px;\n  background: rgba(29, 90, 124, 0.06);\n}\n\n.finiquitos-row-list {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.finiquitos-concept-picker {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.8rem;\n  margin: var(--ui-space-3) 0 var(--ui-space-4);\n  padding: 0.85rem;\n  border: 1px solid rgba(42, 78, 102, 0.12);\n  border-radius: var(--ui-radius-lg);\n  background: linear-gradient(180deg, rgba(245, 250, 253, 0.9), rgba(255, 255, 255, 0.88));\n}\n\n.finiquitos-concept-picker-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.finiquitos-concept-picker-head span:not(.status-badge) {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-concept-picker-head p {\n  margin: 0.18rem 0 0;\n  color: var(--ui-text-soft);\n  font-size: 0.86rem;\n}\n\n.finiquitos-concept-select-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.65rem;\n  align-items: end;\n}\n\n.finiquitos-concept-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.45rem;\n  max-height: 11.5rem;\n  overflow: auto;\n  padding-right: 0.15rem;\n}\n\n.finiquitos-concept-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  min-height: 2.55rem;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid rgba(42, 78, 102, 0.12);\n  border-radius: var(--ui-radius-md);\n  background: rgba(255, 255, 255, 0.8);\n  color: var(--ui-text);\n  cursor: pointer;\n  transition:\n    border-color 140ms ease,\n    background 140ms ease,\n    box-shadow 140ms ease;\n}\n\n.finiquitos-concept-option:hover {\n  border-color: rgba(29, 90, 124, 0.28);\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.finiquitos-concept-option.selected {\n  border-color: rgba(20, 114, 79, 0.28);\n  background: rgba(20, 114, 79, 0.08);\n  box-shadow: inset 3px 0 0 rgba(20, 114, 79, 0.55);\n}\n\n.finiquitos-concept-option input {\n  margin-top: 0.12rem;\n}\n\n.finiquitos-concept-option span {\n  font-size: 0.86rem;\n  line-height: 1.25;\n}\n\n.finiquitos-concept-picker .btn {\n  justify-self: end;\n}\n\n.finiquitos-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.25fr) minmax(120px, 0.42fr) minmax(0, 1fr) auto;\n  gap: 0.7rem;\n  align-items: end;\n}\n\n.finiquitos-row.with-type {\n  grid-template-columns: minmax(140px, 0.55fr) minmax(0, 1.2fr) minmax(120px, 0.42fr) minmax(0, 1fr) auto;\n}\n\n.compact-field {\n  min-width: 0;\n}\n\n.compact-field span {\n  font-size: 0.72rem;\n}\n\n.grow {\n  min-width: 0;\n}\n\n.amount-field {\n  max-width: 8.5rem;\n}\n\n.remove-row-btn {\n  align-self: center;\n  min-width: 2.4rem;\n  padding-inline: 0;\n}\n\n.finiquitos-summary-panel {\n  position: sticky;\n  top: 0.75rem;\n}\n\n.finiquitos-alert {\n  padding: 0.9rem 1rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid var(--ui-border);\n  background: rgba(255, 255, 255, 0.92);\n}\n\n.finiquitos-alert strong {\n  display: block;\n  margin-bottom: 0.35rem;\n}\n\n.finiquitos-alert ul {\n  margin: 0;\n  padding-left: 1.1rem;\n}\n\n.finiquitos-alert.danger {\n  border-color: rgba(156, 60, 50, 0.22);\n  background: rgba(156, 60, 50, 0.08);\n  color: #7f291f;\n}\n\n.finiquitos-alert.warning {\n  border-color: rgba(149, 109, 21, 0.22);\n  background: rgba(149, 109, 21, 0.08);\n  color: #7a5a12;\n}\n\n.finiquitos-summary-grid,\n.finiquitos-insight-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.7rem;\n}\n\n.finiquitos-summary-card,\n.finiquitos-insight-grid > div {\n  display: grid;\n  gap: 0.18rem;\n  padding: 0.85rem 0.95rem;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  background: rgba(255, 255, 255, 0.86);\n}\n\n.finiquitos-summary-card span,\n.finiquitos-insight-grid span {\n  font-size: 0.72rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-summary-card strong,\n.finiquitos-insight-grid strong {\n  font-size: 1rem;\n  color: var(--ui-text);\n}\n\n.finiquitos-summary-card.emphasized {\n  background: linear-gradient(135deg, rgba(29, 90, 124, 0.11), rgba(20, 114, 79, 0.08));\n  border-color: rgba(29, 90, 124, 0.22);\n}\n\n.finiquitos-doc-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.7rem;\n}\n\n.finiquitos-doc-summary-item {\n  display: grid;\n  gap: 0.18rem;\n  padding: 0.8rem 0.9rem;\n  border: 1px solid rgba(29, 90, 124, 0.14);\n  border-radius: var(--ui-radius-lg);\n  background: rgba(29, 90, 124, 0.05);\n}\n\n.finiquitos-doc-summary-item span {\n  font-size: 0.72rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-doc-summary-item strong {\n  font-size: 0.95rem;\n  color: var(--ui-text);\n}\n\n.finiquitos-document-preview {\n  display: grid;\n  gap: 0.85rem;\n  padding: 1rem;\n  border: 1px solid rgba(29, 90, 124, 0.14);\n  border-radius: var(--ui-radius-lg);\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(245, 250, 253, 0.96));\n}\n\n.finiquitos-document-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.7rem;\n}\n\n.finiquitos-document-meta > div {\n  display: grid;\n  gap: 0.18rem;\n  padding: 0.75rem 0.85rem;\n  border-radius: var(--ui-radius-md);\n  border: 1px solid rgba(42, 78, 102, 0.11);\n  background: rgba(255, 255, 255, 0.82);\n}\n\n.finiquitos-document-meta span,\n.finiquitos-document-table thead th,\n.finiquitos-neto-box span,\n.finiquitos-neto-box small {\n  font-size: 0.68rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-document-meta strong {\n  font-size: 0.92rem;\n  color: var(--ui-text);\n  word-break: break-word;\n}\n\n.finiquitos-document-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(42, 78, 102, 0.12);\n  border-radius: var(--ui-radius-lg);\n  overflow: hidden;\n}\n\n.finiquitos-document-table th,\n.finiquitos-document-table td {\n  padding: 0.7rem 0.8rem;\n  border-bottom: 1px solid rgba(42, 78, 102, 0.08);\n  vertical-align: top;\n}\n\n.finiquitos-document-table thead th {\n  background: rgba(29, 90, 124, 0.06);\n  font-weight: 700;\n}\n\n.finiquitos-document-table tbody td strong {\n  display: block;\n}\n\n.finiquitos-document-table tbody td small {\n  display: block;\n  margin-top: 0.1rem;\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-document-table .amount-col {\n  width: 12rem;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.finiquitos-document-table tfoot th {\n  background: rgba(29, 90, 124, 0.04);\n  font-weight: 800;\n}\n\n.finiquitos-document-table .placeholder {\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-neto-box {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.6rem;\n  padding: 0.85rem 0.95rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid rgba(20, 114, 79, 0.18);\n  background: linear-gradient(135deg, rgba(20, 114, 79, 0.1), rgba(29, 90, 124, 0.06));\n}\n\n.finiquitos-neto-box strong {\n  font-size: 1.1rem;\n  color: var(--ui-text);\n}\n\n.finiquitos-generation-block {\n  display: grid;\n  gap: 0.75rem;\n  padding: 1rem;\n  border: 1px solid rgba(29, 90, 124, 0.14);\n  border-radius: var(--ui-radius-lg);\n  background: linear-gradient(180deg, rgba(29, 90, 124, 0.06), rgba(255, 255, 255, 0.94));\n}\n\n.finiquitos-generation-meta,\n.finiquitos-document-card-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.7rem;\n}\n\n.finiquitos-generation-meta > div,\n.finiquitos-document-card-grid > div {\n  display: grid;\n  gap: 0.18rem;\n  padding: 0.75rem 0.85rem;\n  border-radius: var(--ui-radius-md);\n  border: 1px solid rgba(42, 78, 102, 0.11);\n  background: rgba(255, 255, 255, 0.82);\n}\n\n.finiquitos-generation-meta span,\n.finiquitos-document-card-grid span {\n  font-size: 0.68rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-generation-meta strong,\n.finiquitos-document-card-grid strong {\n  font-size: 0.92rem;\n  color: var(--ui-text);\n  word-break: break-word;\n}\n\n.finiquitos-document-list {\n  display: grid;\n  gap: 0.8rem;\n}\n\n.finiquitos-document-card {\n  display: grid;\n  gap: 0.8rem;\n  padding: 0.95rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid rgba(29, 90, 124, 0.14);\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.finiquitos-document-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.finiquitos-document-kind {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-document-card h4 {\n  margin: 0.15rem 0 0;\n  font-size: 1rem;\n}\n\n.finiquitos-document-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.7rem;\n  align-items: center;\n}\n\n.finiquitos-line-items {\n  display: grid;\n  gap: 0.55rem;\n}\n\n.finiquitos-line-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.7rem 0.85rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid rgba(42, 78, 102, 0.11);\n  background: rgba(255, 255, 255, 0.76);\n}\n\n.finiquitos-line-item strong {\n  display: block;\n}\n\n.finiquitos-line-item small {\n  color: var(--ui-text-soft);\n}\n\n.finiquitos-line-item .credit {\n  color: var(--ui-success);\n  font-weight: 700;\n}\n\n.finiquitos-line-item .debit {\n  color: var(--ui-danger);\n  font-weight: 700;\n}\n\n.finiquitos-approval-box {\n  display: grid;\n  gap: 0.85rem;\n  padding: 1rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid rgba(29, 90, 124, 0.14);\n  background: linear-gradient(180deg, rgba(245, 250, 253, 0.95), rgba(255, 255, 255, 0.98));\n}\n\n.approval-check {\n  display: flex;\n  gap: 0.7rem;\n  align-items: flex-start;\n  color: var(--ui-text);\n  font-weight: 600;\n}\n\n.approval-check.secondary {\n  padding: 0.7rem 0.8rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid rgba(149, 109, 21, 0.18);\n  background: rgba(149, 109, 21, 0.06);\n}\n\n.approval-check input {\n  margin-top: 0.2rem;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.helper-text.warning {\n  color: var(--ui-warning);\n}\n\n.helper-text.success {\n  color: var(--ui-success);\n}\n\n@media (max-width: 1100px) {\n  .finiquitos-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .finiquitos-side,\n  .finiquitos-summary-panel {\n    position: static;\n  }\n}\n\n@media (max-width: 960px) {\n  .finiquitos-header {\n    flex-direction: column;\n  }\n\n  .finiquitos-status-stack {\n    justify-content: flex-start;\n  }\n\n  .finiquitos-grid-two,\n  .finiquitos-grid-three,\n  .finiquitos-summary-grid,\n  .finiquitos-insight-grid,\n  .finiquitos-doc-summary,\n  .finiquitos-document-meta,\n  .finiquitos-search-tools,\n  .finiquitos-generation-meta,\n  .finiquitos-document-card-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .finiquitos-concept-options {\n    grid-template-columns: 1fr;\n  }\n\n  .finiquitos-concept-picker-head {\n    flex-direction: column;\n  }\n\n  .finiquitos-concept-select-row {\n    grid-template-columns: 1fr;\n  }\n\n  .finiquitos-concept-picker .btn {\n    justify-self: stretch;\n  }\n\n  .finiquitos-row,\n  .finiquitos-row.with-type {\n    grid-template-columns: 1fr;\n  }\n\n  .amount-field {\n    max-width: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .finiquitos-panel,\n  .finiquitos-subpanel,\n  .finiquitos-header {\n    padding: var(--ui-space-4);\n  }\n\n  .Spreadsheet {\n    min-width: 440px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
